var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transition',[(_vm.visible)?_c('div',{staticClass:"w-100 h-100 d-flex justify-content-center align-items-center pre-loader bg-dark flex-column"},[_c('div',{staticClass:"loader"}),_c('p',{staticClass:"m-0 mt-4 text-light fs-4"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }